import { Link } from '@tanstack/react-router';
import { ReadonlyList, type ReadonlyListProps } from '@interxfi/design-system/components/list/readonly/readonly-list';

export function AppReadonlyList(props: ReadonlyListProps) {
  return <ReadonlyList defaultLinkElement={Link} {...props} />;
}
